import { useEffect, useRef, useState } from "react";
import Footer from "./Footer/Footer";
import "./css/flaticon.min.css";
import "./css/fontawesome-5.14.0.min.css";
import "./Main.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import SideBar from "./Home/SideBar";
import HomeMenu from "./Home/HomeMenu";
import MobileMenuHome from "./Home/MobileMenuHome";
import { sideBarToggle } from "./Home/utils";
import { Col, Container, Row } from "react-bootstrap";
import { FaCheck } from "react-icons/fa6";
import CountUp from "react-countup";

const Aboutus = () => {
  const [scrolled, setScrolled] = useState(false);



  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;

      // Determine the scroll threshold where the header should become fixed
      const scrollThreshold = 100;

      // Update the state based on the scroll position
      setScrolled(scrollTop > scrollThreshold);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Remove scroll event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const valueRef = useRef<HTMLDivElement | null>(null);
  const projectRef = useRef<HTMLDivElement | null>(null);
  const teamRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateValue(valueRef, 0, 2365, 1000);
          animateValue(projectRef, 0, 5234, 1000);
          animateValue(teamRef, 0, 8532, 1000);
        }
      });
    }, options);

    if (valueRef.current) observer.observe(valueRef.current);
    if (projectRef.current) observer.observe(projectRef.current);
    if (teamRef.current) observer.observe(teamRef.current);
  }, []);

  function animateValue(obj: any, start: any, end: any, duration: any) {
    let startTimestamp: any = null;

    const step = (timestamp: any) => {
      if (!startTimestamp) startTimestamp = timestamp;

      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const currentValue = Math.floor(progress * (end - start) + start);
      obj.current.innerText = currentValue.toString() + "+";

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }



  const [triggerCount, setTriggerCount] = useState(false);
  const sectionRef = useRef<any>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setTriggerCount(true);
        }
      },
      {
        root: null,
        threshold: 0.2,
      }
    );

    // 1. Copy the current ref value to a variable
    const currentSection = sectionRef.current;

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      // 2. Use the variable in the cleanup function
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []); // Empty dependency array is fine since we use the captured variable


  return (
    <>
      <Helmet>
        <title>About Us</title>
        <meta
          name="description"
          content=" We're a software development company that builds products for companies worldwide."
        />
      </Helmet>


      <header
        className={`main-header header-two ${scrolled ? "fixed-header" : ""}`}
      >
        {/*Header-Upper*/}
        <div className="header-upper1">
          <div className="container clearfix">
            <div className="header-inner rel d-flex align-items-center justify-content-between">
              <div className="logo-outer">
                <div className="logo">
                  <Link to="/">

                    <img
                      src="/assets/tth_logo.png"
                      alt="Logo"
                      title="Logo"
                      style={{ height: "45px", width: "auto" }}
                    />

                  </Link>
                </div>
              </div>
              <div className="nav-outer clearfix mx-0">
                <MobileMenuHome logo={"/images/logos/logo-two.png"} />
                {/* Main Menu */}
                <nav className="main-menu d-none d-lg-block navbar-expand-lg">
                  <div className="navbar-header">
                    <div className="mobile-logo my-15">
                      <Link to="/">

                        <img
                          src="/images/logos/logo-two.png"
                          alt="Logo"
                          title="Logo"
                        />

                      </Link>
                    </div>
                    {/* Toggle Button */}
                    <button
                      type="button"
                      className="navbar-toggle"
                      data-bs-toggle="collapse"
                      data-bs-target=".navbar-collapse"
                    >
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                    </button>
                  </div>
                  <div className="navbar-collapse collapse clearfix">
                    <HomeMenu />
                  </div>
                </nav>
                {/* Main Menu End*/}
              </div>
              {/* Menu Button */}
              <div className="menu-btns">
                <div className="menu-sidebar d-none d-lg-block">
                  <button onClick={() => sideBarToggle()}>
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                  </button>
                  <SideBar />
                </div>
              </div>
            </div>
          </div>
        </div>

      </header>







      <section
        className="pt-130 pb-70 "
        style={{ backgroundColor: "#011C2B" }}
      >
        <section className="advisor-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-start align-items-center">
                <div className="abis ">
                  <h1 className="wow fadeInUp delay-0-4s">Meet Our Advisor</h1>
                  <p className="wow fadeInUp delay-0-4s">As a visionary in marketing and business growth, Racheal brings a dynamic approach to The TechHorse mission. Based in Atlanta, USA, she excels at crafting impactful strategies that fuel brand expansion, foster meaningful connections, and ensure sustained growth for our clients.</p>
                  <span className="wow fadeInUp delay-0-4s">-Racheal,  USA Atlanta</span>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center">
                <div className=" position-relative">

                  <img src="/assets/yu.webp" alt="img" className="img-fluid yu wow fadeIn delay-0-3s" loading="lazy" />
                  <img src="/assets/oip.webp" alt="img" className="img-fluid kjd wow fadeInUp delay-0-4s" loading="lazy" />

                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="advisor-section">
          <div className="container py-5">
            <div className="row align-items-center flex-lg-row-reverse">

              <div className="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-start align-items-center">
                <div className="abis">
                  <h1 className="wow fadeInUp delay-0-4s">Meet Our CEO</h1>

                  <p className="wow fadeInUp delay-0-4s">
                    At the heart of our organization is a vision to create innovative digital solutions that drive business success. Our CEO leads with integrity, innovation, and a customer-centric approach, empowering our talented team to deliver reliable, scalable, and future-ready technology solutions. Together, we are committed to helping businesses embrace digital transformation with confidence.

                  </p>

                  <span className="wow fadeInUp delay-0-4s">
                    -Mohammad Omar, India
                  </span>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center">
                <div className="position-relative">
                  <img
                    src="/assets/yu.webp"
                    alt="img"
                    className="img-fluid yu wow fadeIn delay-0-3s"
                    loading="lazy"
                  />
                  <img
                    src="/assets/man.png"
                    alt="img"
                    className="img-fluid kjd wow fadeInUp delay-0-4s"
                    loading="lazy"
                  />
                </div>
              </div>

            </div>
          </div>
        </section>
      </section>





      <section
        className="aus mb-5"
        ref={sectionRef}
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        <Container>
          <Row style={{ height: "100%" }}>
            <Col xs={12} md={12} lg={6} className="  ">
              <div>
                <p className="tit wow fadeInUp delay-0-4s">\ About Us \</p>
                <p className="a-head wow fadeInUp delay-0-4s">The TechHorse Technology</p>
                <p className="a-text wow fadeInUp delay-0-4s">
                  The TechHorse is a trusted name in the IT industry with over
                  20 years of excellence. We are a company of dynamic and
                  experienced key employees who share the goal of providing you
                  with cool, scalable, and reliable technology solutions for
                  your business needs.
                </p>
                <p className="a-text wow fadeInUp delay-0-4s">
                  It all started with a clear vision — to enable businesses with
                  the most advanced digital solutions that would increase growth
                  and efficiency. Over the years, we have grown into a top IT
                  powerhouse, catering to clients in various industries and
                  geographies.
                </p>
              </div>
            </Col>

            <Col xs={12} md={12} lg={6} className="" style={{ height: "100%" }}>
              <div className="cl-cont">
                <img
                  src="/assets/about-us-img-1.png"
                  alt="about-us-img"
                  loading="lazy"
                  className="about-img about-img-1 img-fluid"
                />
                <img
                  src="/assets/about-us-img-2.png"
                  alt="about-us-img"
                  loading="lazy"
                  className="about-img about-img-2 img-fluid"
                />
                <img
                  src="/assets/about-us-img-3.png"
                  alt="about-us-img"
                  loading="lazy"
                  className="about-img about-img-3 img-fluid"
                />
                <div className="y-circle wow fadeInUp delay-0-4s">
                  {triggerCount &&
                    <span className="y-head"><CountUp end={12} duration={2} suffix="+" /> Years</span>}
                  <br />
                  <span className="y-txt">EXPERIENCE</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className="aus-2 mb-5"
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        <Container>
          <Row>
            <Col xs={12} md={12} lg={6} className="  ">
              <div>
                <p className="tit wow fadeInUp delay-0-4s">\ What We Do \</p>
                <p className="a-head-2 wow fadeInUp delay-0-4s">
                  <span>
                    Providing The <span className="a-head-cl ">Best</span>{" "}
                  </span>
                  <br />
                  <div className="mt-2">
                    <span>Services</span>
                  </div>
                </p>
                <div className="d-flex justify-content-between mb-2 wow fadeInUp delay-0-4s">
                  <div className="li-a me-4">
                    <FaCheck className="tk" />
                  </div>
                  <div>
                    <p className="tk-tit">Business Automation</p>
                    <p className="a-w-txt mt-1">
                      Transform your business with intelligent automation solutions that simplify
                      processes, eliminate repetitive tasks, improve team productivity, and drive
                      operational excellence for faster business growth.
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-2 wow fadeInUp delay-0-4s">
                  <div className="li-a me-4">
                    <FaCheck className="tk" />
                  </div>
                  <div>
                    <p className="tk-tit">Mobile App Development</p>
                    <p className="a-w-txt mt-1">
                      To access your customers on the move in the most high performing mobile application for the android and iOS platform.
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-2 wow fadeInUp delay-0-4s">
                  <div className="li-a me-4">
                    <FaCheck className="tk" />
                  </div>
                  <div>
                    <p className="tk-tit">DevOps</p>
                    <p className="a-w-txt mt-1">
                      Enhance collaboration, deployment speed, and product quality with our DevOps automation and integration services.
                    </p>
                  </div>
                </div>



              </div>
            </Col>

            <Col xs={12} md={12} lg={6} className=" order-xs-2 order-2 ">
              <div className="cl-cont">
                <div className="cont-w">
                  <img
                    src="/assets/why-a.png"
                    alt="about-us-img"
                    loading="lazy"
                    className="why-a-img"
                  />

                  <img
                    src="/assets/w-d.png"
                    alt="about-us-img"
                    loading="lazy"
                    className="w-d-img"
                  />
                </div>

                <div className="w-circle wow fadeInUp delay-0-4s">
                  <div className="w-i-circle"></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>


      <section className="pt-50 pb-50">
        <p className="tit text-center">\ Expert Team\</p>
        <p className="a-head text-center">
          <span>Shaping your digital success</span>
          <br />
          <span>journey</span>{" "}
        </p>

        <Container>
          <Row>

            <Col xs={12} md={12} lg={4}>
              <div className="d-flex justify-content-around  bbct">
                <div className="li-a me-4">
                  <FaCheck className="tkn" />
                </div>
                <div>
                  <p className="tk-titn">Design Team</p>
                  <p className="a-w-txt mt-1">
                    Creative designers at our agency make designs that look eye-catching and are organized to guide the users. Those talents focus on designing posts for social media, captivating Reels and creating impressive UI/UX interfaces. Every design reflects the brand standards and aims to engage users more. You can rely on them to leave a long-lasting impact on your brand on the web.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} lg={4}>

              <div className="d-flex justify-content-around  bbr  bbct">
                <div className="li-a me-4">
                  <FaCheck className="tkn" />
                </div>
                <div>
                  <p className="tk-titn">Digital Marketing Experts</p>
                  <p className="a-w-txt mt-1">
                    Our team of digital marketers develops successful strategies that help our clients achieve their goals.They manage all aspects of social media marketing, optimize sites for search engines and manage Google Ads to help increase visibility. Their work ensures that the brand grows by boosting awareness and creating new leads.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} lg={4}>
              <div className="d-flex justify-content-around  bbct">
                <div className="li-a me-4">
                  <FaCheck className="tkn" />
                </div>
                <div>
                  <p className="tk-titn">Software Testers</p>
                  <p className="a-w-txt mt-1">
                    The team responsible for testing your software ensures that everything functions smoothly on every system and in every condition. With the help of Selenium, developers test their work manually or automatically to spot and solve any present issues. They check if the software is usable, functions properly, is compatible and runs well before it is released.
                    All our projects are thoroughly tested to ensure that their quality is always high.

                  </p>
                </div>
              </div>
            </Col>
          </Row>
          {/* <hr className="oline" /> */}

          <div className="oline mx-auto ">


          </div>




          <Row>
            <Col xs={12} md={12} lg={6}>
              <div className="d-flex justify-content-around mb-2 bbl pt-4 bbct">
                <div className="li-a me-4">
                  <FaCheck className="tkn" />
                </div>
                <div>
                  <p className="tk-titn">Frontend Developers</p>
                  <p className="a-w-txt mt-1">
                    The frontend team is skilled at building user interfaces that work smoothly on all devices.
                    Programmers build out the experiences online with tools like React JS.
                    Web designers ensure that websites are easy to use on any device and for anyone.
                    The website is made to feel smooth and easy to navigate for anyone visiting it.
                    They help users observe your brand and have a pleasant time exploring it.

                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} lg={6}>
              <div className="d-flex justify-content-around mb-2 pt-4 bbct">
                <div className="li-a me-4">
                  <FaCheck className="tkn" />
                </div>
                <div>
                  <p className="tk-titn">Backend Developers</p>
                  <p className="a-w-txt mt-1">
                    The backend team handles the creation of the engine used in your digital products.
                    They rely on Node.js to ensure the server-side code is safe, scalable and efficient.
                    They are responsible for making sure data is safely and correctly transferred in the company, including using APIs.They focus their efforts on clean, fast and real-time systems.
                    They ensure that your application runs smoothly in the background.

                  </p>
                </div>
              </div>

            </Col>

          </Row>
        </Container>
      </section>





      <Footer />
    </>
  );
};

export default Aboutus;
